'use client'
import {Col, ConfigProvider, Flex, List, Row, Typography} from "antd";
import Icon, {EnvironmentOutlined, MailOutlined, PhoneOutlined, RightOutlined, WhatsAppOutlined} from "@ant-design/icons";
import React, {CSSProperties} from "react";
import {useTranslations} from "next-intl";
import {Constants} from "@/src/lib/constants";
const { Link } = Typography;
import Facebook from "@/public/assets/svg/facebook.svg";
import GooglePlus from "@/public/assets/svg/google-plus.svg";
import Instagram from "@/public/assets/svg/instagram.svg";
import LocationPin from "@/public/assets/svg/location-pin-1.svg";
import Whatsapp from "@/public/assets/svg/whatsapp.svg";
import {ThemeService} from "@/src/services/theme";
import './footer.css';
import useBreakpoint from "antd/lib/grid/hooks/useBreakpoint";
import {usePathname} from "@/src/i18n/routing";

const FooterComponent = () => {
    const localization = useTranslations('footer');
    const themeColors = ThemeService.getThemeColors()
    const menuSectionTitle: CSSProperties = {textAlign: "left", marginTop: 10, marginBottom: 15}
    const linkStyle: CSSProperties = { /*color: props.colors.menuBarColor*/ }
    const listStyle: CSSProperties = { textAlign: "left", padding: "8px 0" }
    const chevronStyle: CSSProperties = {color: themeColors.menuBarColor, fontSize: 10, marginRight: 8}
    const breakpoint = useBreakpoint()
    const pathname = usePathname();

    const getLinks = () => {
        return [
            {href: pathname === "/home" ? "#company" : "/home#company", text: localization("link1")},
            {href: pathname === "/home" ? "#services" : "/home#services", text: localization("link2")},
            {href: pathname === "/home" ? "#lodgings" : "/home#lodgings", text: localization("link3")},
            // {href: "#", text: localization("link4")},
        ]
    }

    const getAccomodations = () => {
        return [
            {href: "/lodging?id=lodging1", text: localization("accomodation1")},
            {href: "/lodging?id=lodging2", text: localization("accomodation2")},
            {href: "/lodging?id=lodging3", text: localization("accomodation3")},
            {href: "/lodging?id=lodging4", text: localization("accomodation4")},
        ]
    }

    const getPrivacy = () => {
        return [
            {href: "/termsandconditions", text: localization("privacy1")},
            {href: "/privacy", text: localization("privacy2")},
        ]
    }

    const getBottomLinks = () => {
        return [
            {href: Constants.whatsappLink, component: Whatsapp},
            {href: Constants.facebookLink, component: Facebook},
            {href: Constants.googlePlusLink, component: GooglePlus},
            {href: Constants.mapsLink, component: LocationPin},
            {href: Constants.instagramLink, component: Instagram}
        ]
    }

    const linkContainerStyle: CSSProperties = {border: "1px solid #2A2A2A", backgroundColor: "#2A2A2A", borderRadius: "50%", padding: 8}

    return (
        <>
            <Row gutter={[16, 16]} style={{margin: "16px"}}>
                <Col xs={24} sm={12} md={4}>
                    <Flex vertical justify={"start"} align={"flex-start"}>
                        <h1 style={{textAlign: "left", marginBottom: 20}}>{Constants.companyName}</h1>
                        <Flex vertical>
                            <h3 className={"footerLine noMargin"}>{localization("vatNumber")}</h3>
                            <p className={"footerLine noMargin"}>{Constants.companyVat}</p>
                        </Flex>
                        <Flex vertical style={{marginTop: 15}}>
                            <h3 className={"footerLine noMargin"}>{localization("cinNumber")}</h3>
                            <p className={"footerLine noMargin"}>{Constants.companyCin}</p>
                        </Flex>
                        <Flex vertical style={{marginTop: 15}}>
                            <h3 className={"footerLine noMargin"}>{localization("registered")}</h3>
                            <p className={"footerLine noMargin"}>{Constants.companyCCIAA}</p>
                        </Flex>
                        <Link href={Constants.mapsLink} className={"mapLink"} target={"_blank"} style={{marginTop: 15, fontWeight: "bold"}}>{localization("drivingDirections")}</Link>
                    </Flex>
                </Col>
                {(()=>{
                    if (breakpoint.sm) {
                        return (
                            <Col xs={24} sm={12} md={5}>
                                <Flex vertical justify={"start"} align={"flex-start"}>
                                    <h3 style={menuSectionTitle}>{localization("linkTitle")}</h3>
                                    <ul style={{listStyle: "none"}}>
                                        {(() => {
                                            return getLinks().map((value, index) => {
                                                return <li key={index} style={listStyle}>
                                                    <Flex vertical={false}>
                                                        <RightOutlined style={chevronStyle}/>
                                                        <Link href={value.href} style={linkStyle}>{value.text}</Link>
                                                    </Flex>
                                                </li>
                                            })
                                        })()}
                                    </ul>
                                </Flex>
                            </Col>
                        )
                    }
                })()}
                {(()=>{
                    if (breakpoint.sm) {
                        return (
                            <Col xs={24} sm={12} md={5}>
                                <Flex vertical justify={"start"} align={"flex-start"}>
                                    <h3 style={menuSectionTitle}>{localization("accomodationTitle")}</h3>
                                    <ul style={{listStyle: "none"}}>
                                        {(() => {
                                            return getAccomodations().map((value, index) => {
                                                return <li key={index} style={listStyle}>
                                                    <Flex vertical={false}>
                                                        <RightOutlined style={chevronStyle}/>
                                                        <Link href={value.href} style={linkStyle}>{value.text}</Link>
                                                    </Flex>
                                                </li>
                                            })
                                        })()}
                                    </ul>
                                </Flex>
                            </Col>
                        )
                    }
                })()}
                {(()=>{
                    if (breakpoint.sm) {
                        return (
                            <Col xs={24} sm={12} md={5}>
                                <h3 style={menuSectionTitle}>{localization("contactUs")}</h3>
                                <Flex vertical={false} justify={"start"} align={"center"}>
                                    <PhoneOutlined rotate={90} className="footerItem"  />
                                    <Flex vertical>
                                        <h3 className={"footerLine"}>{localization("phone")}</h3>
                                        <p className={"footerLine"}>{Constants.companyPhone}</p>
                                    </Flex>
                                </Flex>
                                <Flex vertical={false} justify={"start"} align={"center"} style={{marginTop: 15}}>
                                    <WhatsAppOutlined className="footerItem" />
                                    <Flex vertical>
                                        <h3 className={"footerLine"}>{localization("whatsapp")}</h3>
                                        <p className={"footerLine"}><a href={Constants.whatsappLink} target={"_blank"}>{localization("sendMessage")}</a></p>
                                    </Flex>
                                </Flex>
                                <Flex vertical={false} justify={"start"} align={"center"} style={{marginTop: 15}}>
                                    <MailOutlined className="footerItem" />
                                    <Flex vertical>
                                        <h3 className={"footerLine"}>{localization("email")}</h3>
                                        <p className={"footerLine"}><a href={`mailto:${Constants.companyEmail}`}>{Constants.companyEmail}</a></p>
                                    </Flex>
                                </Flex>
                                <Flex vertical={false} justify={"start"} align={"center"} style={{marginTop: 15}}>
                                    <EnvironmentOutlined className="footerItem" />
                                    <Flex vertical>
                                        <h3 className={"footerLine"}>{localization("location")}</h3>
                                        <p className={"footerLine"}>{Constants.companyFullAddress}</p>
                                    </Flex>
                                </Flex>
                            </Col>
                        )
                    }
                })()}
                <Col xs={24} sm={12} md={5}>
                    <Flex vertical justify={"start"} align={"flex-start"}>
                        <h3 style={menuSectionTitle}>{localization("privacyTitle")}</h3>
                        <ul style={{listStyle: "none"}}>
                            {(() => {
                                return getPrivacy().map((value, index) => {
                                    return <li key={index} style={listStyle}>
                                        <Flex vertical={false}>
                                            <RightOutlined style={chevronStyle}/>
                                            <Link href={value.href} style={linkStyle}>{value.text}</Link>
                                        </Flex>
                                    </li>
                                })
                            })()}
                        </ul>
                    </Flex>
                </Col>
            </Row>
            <Row>
                <Col span={24} style={{margin: "20px 0", fontSize: 13, fontWeight: 200}}>
                    <Flex vertical={false} gap={16} justify={"center"} align={"center"}>
                        {(() => {
                            return getBottomLinks().map((value, index) => {
                                return <a href={value.href} target={"_blank"} className={"bottomLinks"} key={index}>
                                    <div style={linkContainerStyle}>
                                        <Icon component={value.component} style={{fontSize: 24}} />
                                    </div>
                                </a>
                            })
                        })()}
                    </Flex>
                </Col>
            </Row>
            <Row>
                <Col span={24} style={{marginTop: 20, fontSize: 13, fontWeight: 200}}>
                    {`${Constants.companyName} ©${new Date().getFullYear()} Created by Execom Technology`}
                </Col>
            </Row>
        </>
    )
}

export default FooterComponent